import * as React from 'react';

import classnames from 'classnames';

import {SectionLabel} from '../typography/section-label';

import {LinkItem} from './link-item';
import type {NavItem} from './sidebar-nav';

import styles from './sidebar-nav.module.css';

type Props = {
    navItems: NavItem[];
    filteredDisplayLinkIds: string[];
    isBelowHeaderComponent?: boolean;
    noPadding?: boolean;
};

export function NavItems(props: Props) {
    const containerStyleName = classnames({
        [styles['nav-items-scrollable']]: props.isBelowHeaderComponent,
    });

    return (
        <div className={containerStyleName}>
            {props.navItems.map((section, i) => {
                // Links that the search has kept
                const filteredLinks = section.links.filter((link) =>
                    props.filteredDisplayLinkIds.includes(link.id)
                );

                // Don't show the heading if there are no links remaining
                if (filteredLinks.length === 0) return null;

                filteredLinks.sort((a, b) => {
                    if (a.requiresUpgrade && !b.requiresUpgrade) {
                        return 1;
                    } else if (!a.requiresUpgrade && b.requiresUpgrade) {
                        return -1;
                    } else {
                        return 0;
                    }
                });

                const sectionStyleName = classnames({
                    [styles['heading-container--small']]:
                        (!props.isBelowHeaderComponent || i !== 0) && !section.label,
                    [styles['heading-container']]:
                        (!props.isBelowHeaderComponent || i !== 0) && section.label,
                });

                return (
                    <section
                        key={section.id}
                        className={classnames({
                            'pb-32': i === props.navItems.length - 1 && !props.noPadding,
                        })}
                    >
                        <div className={sectionStyleName}>
                            {section.label && <SectionLabel>{section.label}</SectionLabel>}
                        </div>
                        <ul>
                            {filteredLinks.map((link) => (
                                <LinkItem key={link.linkText} {...link} />
                            ))}
                        </ul>
                        {section.footer && <div className='mt-8'>{section.footer}</div>}
                    </section>
                );
            })}
        </div>
    );
}
